import { ɵgetAllInstancesOf, ɵgetDefaultInstanceOf, VERSION, ɵAngularFireSchedulers, ɵAppCheckInstances, ɵzoneWrap } from '@angular/fire';
import { from, timer } from 'rxjs';
import { concatMap, distinct } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { InjectionToken, Optional, NgModule, NgZone, Injector } from '@angular/core';
import { FirebaseApp, FirebaseApps } from '@angular/fire/app';
import { AuthInstances } from '@angular/fire/auth';
import { registerVersion } from 'firebase/app';
import { collectionChanges as collectionChanges$1, collection as collection$1, sortedChanges as sortedChanges$1, auditTrail as auditTrail$1, collectionData as collectionData$1, collectionCountSnap as collectionCountSnap$1, collectionCount as collectionCount$1, doc as doc$1, docData as docData$1, snapToData as snapToData$1, fromRef as fromRef$1 } from 'rxfire/firestore';
import { addDoc as addDoc$1, aggregateFieldEqual as aggregateFieldEqual$1, aggregateQuerySnapshotEqual as aggregateQuerySnapshotEqual$1, and as and$1, arrayRemove as arrayRemove$1, arrayUnion as arrayUnion$1, average as average$1, clearIndexedDbPersistence as clearIndexedDbPersistence$1, collection as collection$2, collectionGroup as collectionGroup$1, connectFirestoreEmulator as connectFirestoreEmulator$1, count as count$1, deleteAllPersistentCacheIndexes as deleteAllPersistentCacheIndexes$1, deleteDoc as deleteDoc$1, deleteField as deleteField$1, disableNetwork as disableNetwork$1, disablePersistentCacheIndexAutoCreation as disablePersistentCacheIndexAutoCreation$1, doc as doc$2, documentId as documentId$1, enableIndexedDbPersistence as enableIndexedDbPersistence$1, enableMultiTabIndexedDbPersistence as enableMultiTabIndexedDbPersistence$1, enableNetwork as enableNetwork$1, enablePersistentCacheIndexAutoCreation as enablePersistentCacheIndexAutoCreation$1, endAt as endAt$1, endBefore as endBefore$1, getAggregateFromServer as getAggregateFromServer$1, getCountFromServer as getCountFromServer$1, getDoc as getDoc$1, getDocFromCache as getDocFromCache$1, getDocFromServer as getDocFromServer$1, getDocs as getDocs$1, getDocsFromCache as getDocsFromCache$1, getDocsFromServer as getDocsFromServer$1, getFirestore as getFirestore$1, getPersistentCacheIndexManager as getPersistentCacheIndexManager$1, increment as increment$1, initializeFirestore as initializeFirestore$1, limit as limit$1, limitToLast as limitToLast$1, loadBundle as loadBundle$1, memoryEagerGarbageCollector as memoryEagerGarbageCollector$1, memoryLocalCache as memoryLocalCache$1, memoryLruGarbageCollector as memoryLruGarbageCollector$1, namedQuery as namedQuery$1, onSnapshot as onSnapshot$1, onSnapshotsInSync as onSnapshotsInSync$1, or as or$1, orderBy as orderBy$1, persistentLocalCache as persistentLocalCache$1, persistentMultipleTabManager as persistentMultipleTabManager$1, persistentSingleTabManager as persistentSingleTabManager$1, query as query$1, queryEqual as queryEqual$1, refEqual as refEqual$1, runTransaction as runTransaction$1, serverTimestamp as serverTimestamp$1, setDoc as setDoc$1, setIndexConfiguration as setIndexConfiguration$1, setLogLevel as setLogLevel$1, snapshotEqual as snapshotEqual$1, startAfter as startAfter$1, startAt as startAt$1, sum as sum$1, terminate as terminate$1, updateDoc as updateDoc$1, waitForPendingWrites as waitForPendingWrites$1, where as where$1, writeBatch as writeBatch$1 } from 'firebase/firestore';
export * from 'firebase/firestore';
class Firestore {
  constructor(firestore) {
    return firestore;
  }
}
const FIRESTORE_PROVIDER_NAME = 'firestore';
class FirestoreInstances {
  constructor() {
    return ɵgetAllInstancesOf(FIRESTORE_PROVIDER_NAME);
  }
}
const firestoreInstance$ = /*#__PURE__*/ /*#__PURE__*/timer(0, 300).pipe( /*#__PURE__*/concatMap(() => from(ɵgetAllInstancesOf(FIRESTORE_PROVIDER_NAME))), /*#__PURE__*/distinct());
const PROVIDED_FIRESTORE_INSTANCES = /*#__PURE__*/new InjectionToken('angularfire2.firestore-instances');
function defaultFirestoreInstanceFactory(provided, defaultApp) {
  const defaultFirestore = ɵgetDefaultInstanceOf(FIRESTORE_PROVIDER_NAME, provided, defaultApp);
  return defaultFirestore && new Firestore(defaultFirestore);
}
function firestoreInstanceFactory(fn) {
  return (zone, injector) => {
    const firestore = zone.runOutsideAngular(() => fn(injector));
    return new Firestore(firestore);
  };
}
const FIRESTORE_INSTANCES_PROVIDER = {
  provide: FirestoreInstances,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_FIRESTORE_INSTANCES]]
};
const DEFAULT_FIRESTORE_INSTANCE_PROVIDER = {
  provide: Firestore,
  useFactory: defaultFirestoreInstanceFactory,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_FIRESTORE_INSTANCES], FirebaseApp]
};
let FirestoreModule = /*#__PURE__*/(() => {
  class FirestoreModule {
    constructor() {
      registerVersion('angularfire', VERSION.full, 'fst');
    }
    static ɵfac = function FirestoreModule_Factory(t) {
      return new (t || FirestoreModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FirestoreModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [DEFAULT_FIRESTORE_INSTANCE_PROVIDER, FIRESTORE_INSTANCES_PROVIDER]
    });
  }
  return FirestoreModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideFirestore(fn, ...deps) {
  return {
    ngModule: FirestoreModule,
    providers: [{
      provide: PROVIDED_FIRESTORE_INSTANCES,
      useFactory: firestoreInstanceFactory(fn),
      multi: true,
      deps: [NgZone, Injector, ɵAngularFireSchedulers, FirebaseApps,
      // Firestore+Auth work better if Auth is loaded first
      [new Optional(), AuthInstances], [new Optional(), ɵAppCheckInstances], ...deps]
    }]
  };
}

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const collectionChanges = /*#__PURE__*/ɵzoneWrap(collectionChanges$1, true);
const collectionSnapshots = /*#__PURE__*/ɵzoneWrap(collection$1, true);
const sortedChanges = /*#__PURE__*/ɵzoneWrap(sortedChanges$1, true);
const auditTrail = /*#__PURE__*/ɵzoneWrap(auditTrail$1, true);
const collectionData = /*#__PURE__*/ɵzoneWrap(collectionData$1, true);
const collectionCountSnap = /*#__PURE__*/ɵzoneWrap(collectionCountSnap$1, true);
const collectionCount = /*#__PURE__*/ɵzoneWrap(collectionCount$1, true);
const docSnapshots = /*#__PURE__*/ɵzoneWrap(doc$1, true);
const docData = /*#__PURE__*/ɵzoneWrap(docData$1, true);
const snapToData = /*#__PURE__*/ɵzoneWrap(snapToData$1, true);
const fromRef = /*#__PURE__*/ɵzoneWrap(fromRef$1, true);

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const addDoc = /*#__PURE__*/ɵzoneWrap(addDoc$1, true);
const aggregateFieldEqual = /*#__PURE__*/ɵzoneWrap(aggregateFieldEqual$1, true);
const aggregateQuerySnapshotEqual = /*#__PURE__*/ɵzoneWrap(aggregateQuerySnapshotEqual$1, true);
const and = /*#__PURE__*/ɵzoneWrap(and$1, true);
const arrayRemove = /*#__PURE__*/ɵzoneWrap(arrayRemove$1, true);
const arrayUnion = /*#__PURE__*/ɵzoneWrap(arrayUnion$1, true);
const average = /*#__PURE__*/ɵzoneWrap(average$1, true);
const clearIndexedDbPersistence = /*#__PURE__*/ɵzoneWrap(clearIndexedDbPersistence$1, true);
const collection = /*#__PURE__*/ɵzoneWrap(collection$2, true);
const collectionGroup = /*#__PURE__*/ɵzoneWrap(collectionGroup$1, true);
const connectFirestoreEmulator = /*#__PURE__*/ɵzoneWrap(connectFirestoreEmulator$1, true);
const count = /*#__PURE__*/ɵzoneWrap(count$1, true);
const deleteAllPersistentCacheIndexes = /*#__PURE__*/ɵzoneWrap(deleteAllPersistentCacheIndexes$1, true);
const deleteDoc = /*#__PURE__*/ɵzoneWrap(deleteDoc$1, true);
const deleteField = /*#__PURE__*/ɵzoneWrap(deleteField$1, true);
const disableNetwork = /*#__PURE__*/ɵzoneWrap(disableNetwork$1, true);
const disablePersistentCacheIndexAutoCreation = /*#__PURE__*/ɵzoneWrap(disablePersistentCacheIndexAutoCreation$1, true);
const doc = /*#__PURE__*/ɵzoneWrap(doc$2, true);
const documentId = /*#__PURE__*/ɵzoneWrap(documentId$1, true);
const enableIndexedDbPersistence = /*#__PURE__*/ɵzoneWrap(enableIndexedDbPersistence$1, true);
const enableMultiTabIndexedDbPersistence = /*#__PURE__*/ɵzoneWrap(enableMultiTabIndexedDbPersistence$1, true);
const enableNetwork = /*#__PURE__*/ɵzoneWrap(enableNetwork$1, true);
const enablePersistentCacheIndexAutoCreation = /*#__PURE__*/ɵzoneWrap(enablePersistentCacheIndexAutoCreation$1, true);
const endAt = /*#__PURE__*/ɵzoneWrap(endAt$1, true);
const endBefore = /*#__PURE__*/ɵzoneWrap(endBefore$1, true);
const getAggregateFromServer = /*#__PURE__*/ɵzoneWrap(getAggregateFromServer$1, true);
const getCountFromServer = /*#__PURE__*/ɵzoneWrap(getCountFromServer$1, true);
const getDoc = /*#__PURE__*/ɵzoneWrap(getDoc$1, true);
const getDocFromCache = /*#__PURE__*/ɵzoneWrap(getDocFromCache$1, true);
const getDocFromServer = /*#__PURE__*/ɵzoneWrap(getDocFromServer$1, true);
const getDocs = /*#__PURE__*/ɵzoneWrap(getDocs$1, true);
const getDocsFromCache = /*#__PURE__*/ɵzoneWrap(getDocsFromCache$1, true);
const getDocsFromServer = /*#__PURE__*/ɵzoneWrap(getDocsFromServer$1, true);
const getFirestore = /*#__PURE__*/ɵzoneWrap(getFirestore$1, true);
const getPersistentCacheIndexManager = /*#__PURE__*/ɵzoneWrap(getPersistentCacheIndexManager$1, true);
const increment = /*#__PURE__*/ɵzoneWrap(increment$1, true);
const initializeFirestore = /*#__PURE__*/ɵzoneWrap(initializeFirestore$1, true);
const limit = /*#__PURE__*/ɵzoneWrap(limit$1, true);
const limitToLast = /*#__PURE__*/ɵzoneWrap(limitToLast$1, true);
const loadBundle = /*#__PURE__*/ɵzoneWrap(loadBundle$1, true);
const memoryEagerGarbageCollector = /*#__PURE__*/ɵzoneWrap(memoryEagerGarbageCollector$1, true);
const memoryLocalCache = /*#__PURE__*/ɵzoneWrap(memoryLocalCache$1, true);
const memoryLruGarbageCollector = /*#__PURE__*/ɵzoneWrap(memoryLruGarbageCollector$1, true);
const namedQuery = /*#__PURE__*/ɵzoneWrap(namedQuery$1, true);
const onSnapshot = /*#__PURE__*/ɵzoneWrap(onSnapshot$1, true);
const onSnapshotsInSync = /*#__PURE__*/ɵzoneWrap(onSnapshotsInSync$1, true);
const or = /*#__PURE__*/ɵzoneWrap(or$1, true);
const orderBy = /*#__PURE__*/ɵzoneWrap(orderBy$1, true);
const persistentLocalCache = /*#__PURE__*/ɵzoneWrap(persistentLocalCache$1, true);
const persistentMultipleTabManager = /*#__PURE__*/ɵzoneWrap(persistentMultipleTabManager$1, true);
const persistentSingleTabManager = /*#__PURE__*/ɵzoneWrap(persistentSingleTabManager$1, true);
const query = /*#__PURE__*/ɵzoneWrap(query$1, true);
const queryEqual = /*#__PURE__*/ɵzoneWrap(queryEqual$1, true);
const refEqual = /*#__PURE__*/ɵzoneWrap(refEqual$1, true);
const runTransaction = /*#__PURE__*/ɵzoneWrap(runTransaction$1, true);
const serverTimestamp = /*#__PURE__*/ɵzoneWrap(serverTimestamp$1, true);
const setDoc = /*#__PURE__*/ɵzoneWrap(setDoc$1, true);
const setIndexConfiguration = /*#__PURE__*/ɵzoneWrap(setIndexConfiguration$1, true);
const setLogLevel = /*#__PURE__*/ɵzoneWrap(setLogLevel$1, true);
const snapshotEqual = /*#__PURE__*/ɵzoneWrap(snapshotEqual$1, true);
const startAfter = /*#__PURE__*/ɵzoneWrap(startAfter$1, true);
const startAt = /*#__PURE__*/ɵzoneWrap(startAt$1, true);
const sum = /*#__PURE__*/ɵzoneWrap(sum$1, true);
const terminate = /*#__PURE__*/ɵzoneWrap(terminate$1, true);
const updateDoc = /*#__PURE__*/ɵzoneWrap(updateDoc$1, true);
const waitForPendingWrites = /*#__PURE__*/ɵzoneWrap(waitForPendingWrites$1, true);
const where = /*#__PURE__*/ɵzoneWrap(where$1, true);
const writeBatch = /*#__PURE__*/ɵzoneWrap(writeBatch$1, true);

/**
 * Generated bundle index. Do not edit.
 */

export { Firestore, FirestoreInstances, FirestoreModule, addDoc, aggregateFieldEqual, aggregateQuerySnapshotEqual, and, arrayRemove, arrayUnion, auditTrail, average, clearIndexedDbPersistence, collection, collectionChanges, collectionCount, collectionCountSnap, collectionData, collectionGroup, collectionSnapshots, connectFirestoreEmulator, count, deleteAllPersistentCacheIndexes, deleteDoc, deleteField, disableNetwork, disablePersistentCacheIndexAutoCreation, doc, docData, docSnapshots, documentId, enableIndexedDbPersistence, enableMultiTabIndexedDbPersistence, enableNetwork, enablePersistentCacheIndexAutoCreation, endAt, endBefore, firestoreInstance$, fromRef, getAggregateFromServer, getCountFromServer, getDoc, getDocFromCache, getDocFromServer, getDocs, getDocsFromCache, getDocsFromServer, getFirestore, getPersistentCacheIndexManager, increment, initializeFirestore, limit, limitToLast, loadBundle, memoryEagerGarbageCollector, memoryLocalCache, memoryLruGarbageCollector, namedQuery, onSnapshot, onSnapshotsInSync, or, orderBy, persistentLocalCache, persistentMultipleTabManager, persistentSingleTabManager, provideFirestore, query, queryEqual, refEqual, runTransaction, serverTimestamp, setDoc, setIndexConfiguration, setLogLevel, snapToData, snapshotEqual, sortedChanges, startAfter, startAt, sum, terminate, updateDoc, waitForPendingWrites, where, writeBatch };
